export interface CreateAdvertDTO {
  customerId: string;
  contactId: string;
  vehicleId: string;
}
